import React from 'react';
import {
  Modal,
  PanelGroup,
  Panel,
} from 'react-bootstrap';
import exact from 'prop-types-exact';
import PropTypes from 'prop-types';

import UserTimeEntryDeleteModalEnhanced from './UserTimeEntryDeleteModalEnhanced';
import TimeEntryCreateEditFormWithDateWrapperEnhanced from '../../forms/TimeEntry/components/TimeEntryCreateEditFormWithDateWrapperEnhanced';

const propTypes = exact({
  showTimeEntryModal: PropTypes.bool.isRequired,
  dispatchHideTimeEntryEditorModal: PropTypes.func.isRequired,
  modalIsCreateEdit: PropTypes.bool.isRequired,
  selectedTimeEntry: PropTypes.object,

  supervisorId: PropTypes.number.isRequired,
  userId: PropTypes.number.isRequired,
  originDate: PropTypes.string.isRequired,

  minEditDate: PropTypes.string.isRequired,
  maxEditDate: PropTypes.string.isRequired,
});

const TimesheetEditorModal = (props) => {
  const {
    showTimeEntryModal,
    dispatchHideTimeEntryEditorModal,
    modalIsCreateEdit,
    selectedTimeEntry,
    supervisorId,
    userId,
    originDate,
    minEditDate,
    maxEditDate,
  } = props;

  let selectedTimeEntryId = null;
  let selectedTimeEntryKey = null;
  if (selectedTimeEntry) {
    selectedTimeEntryId = selectedTimeEntry.id;
    selectedTimeEntryKey = selectedTimeEntry.key;
  }

  return (
    <Modal
      show={showTimeEntryModal}
      onHide={dispatchHideTimeEntryEditorModal}
      backdrop={false}
      aria-labelledby="contained-modal-title"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title">Time Entry</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {selectedTimeEntryId && !modalIsCreateEdit && (
          <UserTimeEntryDeleteModalEnhanced
            timeEntryId={selectedTimeEntryId}
            timeEntryKey={selectedTimeEntryKey}
            userId={userId}
            originDate={originDate}
          />
        )}
        {modalIsCreateEdit && (
          <PanelGroup>
            <Panel>
              <TimeEntryCreateEditFormWithDateWrapperEnhanced
                timeEntryId={selectedTimeEntryId}
                timeEntryKey={selectedTimeEntryKey}
                onSuccess={dispatchHideTimeEntryEditorModal}
                supervisorId={supervisorId}
                userId={userId}
                originDate={originDate}
                minEditDate={minEditDate}
                maxEditDate={maxEditDate}
              />
            </Panel>
          </PanelGroup>
        )}
      </Modal.Body>
    </Modal>
  );
};

TimesheetEditorModal.propTypes = propTypes;

export default TimesheetEditorModal;
